import enTrans from './en';
import jaTrans from './ja';

export default {
  en: enTrans,
  ja: jaTrans,
};
